import React, { Component } from 'react'
import ReactModal from 'react-modal'
import './loginForm.css'
import PreauthInputForm from './PreauthInputForm.js'
import PreauthFooter from './PreauthFooter.js'
import ForgotPasswordForm from './ForgotPasswordForm.js'
import ContactSupportForm from '../ContactSupportForm'
import getLabel from '../../utilities/label.js'
import { unauthApi } from '../../utilities/api.js'
import emailRegEx from '../../utilities/emailRegularExpression.js'
import _ from 'lodash'

export default class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: localStorage.email ? localStorage.email : '',
      password: '',
      password_confirmation: '',
      type: 'login',
      showLoginSupport: false
    }
    this.changeEmail = this.changeEmail.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changePasswordConfirmation = this.changePasswordConfirmation.bind(this)
    this.submit = this.submit.bind(this)
    this.openLoginSupport = this.openLoginSupport.bind(this)
    if(window.location.href.indexOf('forgot_password') > -1) {
      this.state.type = 'forgot'
      if(window.location.href.indexOf('reset') > -1) {
        this.state.type = 'reset'
      }
    }
    window.trackPage('LoginScreen')
  }

  submitForgot(e) {
    e.preventDefault()
    const email = this.state.email
    if (!emailRegEx.test(email)) {
      this.props.flashMessage({
        message: getLabel('bad_email'),
        type: 'error'
      })
      return false
    }
    var data = {
      user: {
        email: email,
      }
    }
    unauthApi.post('/users/password', data).then(() => {
      this.props.flashMessage({
        message: getLabel('forgot_password_message'),
        type: 'success'
      })
      this.setState({
        type: 'login'
      })
    }).catch(() => {
      this.props.flashMessage({
        message: getLabel('bad_email'),
        type: 'error'
      })
    })
  }

  submitReset(e) {
    e.preventDefault()
    const token = _.last(window.location.href.split('/'))
    var data = {
      user: {
        reset_password_token: token,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
      }
    }
    unauthApi.put('/users/password', data).then(() => {
      this.props.flashMessage({
        message: getLabel('password_reset_success'),
        type: 'success'
      })

      // Try to take them to the app first.
      window.location = 'my-evanta-app://'
      window.location = '/'

    }).catch((error) => {
      const errors = error.response.data.errors
      var errorMessage ='Something went wrong'
      if(errors.password){
        errorMessage = getLabel('weak_password')
      }
      if(errors.password_confirmation){
        errorMessage = getLabel('password_mismatch')
      }

      if(errors.reset_password_token) {
        errorMessage = getLabel('reset_token_expired')
      }

      this.props.flashMessage({
        message: errorMessage,
        type: 'error'
      })
    })
  }

  changeEmail(e) {
    this.setState({
      email: e.target.value
    })
  }

  changePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  changePasswordConfirmation(e) {
    this.setState({
      password_confirmation: e.target.value
    })
  }

  submit(e) {
    e.preventDefault()
    const { email, password } = this.state
    var data = {
      user: {
        email: email,
        password: password
      }
    }
    unauthApi.post('/users/sign_in.json', data).then((response) => {
      localStorage.setItem('email', email)
      localStorage.setItem('credentials', JSON.stringify(response.data))
      this.setState({ credentials: response.data })
      window.location.href = '/'
    }).catch((error) => {
      // dont use labels here as cache could not have labels yet (pulled from API)
      let message
      if(error?.response?.status == 503){ message = 'System is down for maintenance. Please try again later.' }
      else if(error?.response?.data?.errors?.includes('account_disabled')){ message = 'This account is no longer active.' }
      else if(error?.response?.data?.errors?.includes('access_denied')){ message = 'Invalid username or password.' }
      else { message = error?.response?.data?.errors }
      this.props.flashMessage({
        message: message,
        type: 'error'
      })
      console.log(error)
    })
  }

  toggleType(type) {
    this.setState({
      type: type,
      showLoginSupport: false
    })
  }

  openLoginSupport() {
    this.setState({
      showLoginSupport: true
    })
  }

  closeLoginSupport() {
    this.setState({
      showLoginSupport: false
    })
  }

  render() {
    const googleStoreUrl = 'https://play.google.com/store/apps/details?id=com.evanta.access'
    const appleStoreUrl = 'https://itunes.apple.com/us/app/evanta365/id910660732?mt=8'
    const privacyPolicyUrl = 'https://www.evanta.com/terms/privacy_policy'
    const termsAndConditionsUrl = 'https://www.evanta.com/terms/terms_and_conditions'
    const email = this.state.email
    const password = this.state.password
    const password_confirmation = this.state.password_confirmation
    return (
      <div className="login-container">
        <div className="login-title-logo">
          <img src='/gartner_c_level_communities_color.svg' alt='' />
        </div>
        { this.state.type === 'login' &&
          <div>
          	<PreauthInputForm
          		changeEmail={ this.changeEmail }
          		changePassword={ this.changePassword }
          		email={ email }
          		password={ this.state.password }
          		submit={ this.submit }
          		openLoginSupport={ this.openLoginSupport } />
          	<PreauthFooter
          		googleStoreUrl={ googleStoreUrl }
          		appleStoreUrl={ appleStoreUrl }
          		privacyPolicyUrl={ privacyPolicyUrl }
          		termsAndConditionsUrl = { termsAndConditionsUrl } />
          </div>
        }
        { this.state.type === 'forgot' &&
          <div className='preauth-input-form'>
          	{ window.trackPage('RequestPasswordScreen') }
          	<ForgotPasswordForm
          		email={ email }
          		changeEmail={ this.changeEmail }
          		submitForgot={ this.submitForgot.bind(this) }
          		cancel={ () => this.toggleType('login') } />
          </div>
        }
        { this.state.type === 'contact' &&
          <div className='preauth-input-form'>
          	<ContactSupportForm
          		email={ email }
          		emailRegEx={ emailRegEx }
          		showEmail={ true }
          		flashMessage={ this.props.flashMessage }
          		cancel={ () => this.toggleType('login') } />
          </div>
        }
        { this.state.type === 'reset' &&
         <div className="container">
         	{ window.trackPage('ResetPasswordScreen') }
         	<h3>{ getLabel('forgot_password') }</h3>
         	<form>
         		<div className='form-group input-wrapper'>
         			<input type='password' className='form-control' placeholder={ getLabel('new_password') } value={ password } onChange={ this.changePassword } />
         		</div>
         		<div className='form-group input-wrapper bottom-input'>
         			<input type='password' className='form-control' placeholder={ getLabel('password_again') } value={ password_confirmation } onChange={ this.changePasswordConfirmation } />
         		</div>
         		<button onClick={ this.submitReset.bind(this) } className='submit-button'>{ getLabel('submit') }</button>
         	</form>
         	<button className='cancel-button' onClick={() => window.location.href = '/'} >{ getLabel('cancel')} </button>
         </div>
        }
        <ReactModal
          className="react-modal"
          isOpen={ this.state.showLoginSupport }
          appElement={ document.querySelector('#root') }>
          <div className='modal-menu-title'>{ getLabel('help_options') }</div>
          <div className="modal-menu-divider" />
          <button
            className='modal-menu-item'
            onClick={() => this.toggleType('forgot')} >
            { getLabel('request_password')}
          </button>
          <div className="modal-menu-divider" />
          <button
            className='modal-menu-item'
            onClick={() => this.toggleType('contact') } >
            { getLabel('contact_support')}
          </button>
          <div className="modal-menu-divider" />
          <button
            className='modal-menu-item'
            onClick={ () => this.setState({ showLoginSupport: false }) }>
            { getLabel('cancel') }
          </button>
        </ReactModal>

      </div>
    )
  }
}
